import React from 'react';
import {Slider} from '@mui/material';
import FrontdeskButton from '$components/FrontdeskButton';
import CheckBox from '$components/CheckBox';
import XCloseIcon from '$assets/svgs/x-close.svg?react';

import './style.scss';

interface PaymentListFilterDropdownProps {
  open: boolean;
  anchorRef: React.RefObject<HTMLDivElement>;
  paymentMethodOptions: string[];
  selectedPaymentMethods: string[];
  handlePaymentMethodChange: (method: string) => void;
  amountRange: number[];
  handleAmountRangeChange: (_: Event, newValue: number | number[]) => void;
  handleResetFilters: () => void;
  handleApplyFilters: () => void;
  minAmount: number;
  maxAmount: number;
  onClose: () => void;
}

export const PaymentListFilterDropdown: React.FC<
  PaymentListFilterDropdownProps
> = ({
  open,
  anchorRef,
  paymentMethodOptions,
  selectedPaymentMethods,
  handlePaymentMethodChange,
  amountRange,
  handleAmountRangeChange,
  handleResetFilters,
  handleApplyFilters,
  minAmount,
  maxAmount,
  onClose,
}) => {
  if (!open) return null;
  return (
    <div className="payment-list-filter-dropdown" ref={anchorRef}>
      <button
        className="payment-list-filter-dropdown__close-button"
        onClick={onClose}
        type="button"
      >
        <XCloseIcon />
      </button>
      <div className="payment-list-filter-dropdown__content">
        <div className="payment-list-filter-dropdown__label">
          Payment method
        </div>
        <div className="payment-list-filter-dropdown__methods">
          {paymentMethodOptions.map(method => {
            const selected = selectedPaymentMethods.includes(method);
            return (
              <div
                key={method}
                className={`payment-list-filter-dropdown__method${selected ? ' selected' : ''}`}
              >
                <span
                  className={`payment-list-filter-dropdown__method-label${selected ? ' selected' : ''}`}
                >
                  {method}
                </span>
                <CheckBox
                  checked={selected}
                  onChange={() => handlePaymentMethodChange(method)}
                  className="no-padding-checkbox"
                />
              </div>
            );
          })}
        </div>
        <div className="payment-list-filter-dropdown__amount-label">Amount</div>
        <div className="payment-list-filter-dropdown__amount-slider">
          <div className="payment-list-filter-dropdown__amount-values">
            <span className="payment-list-filter-dropdown__amount-value">
              £
              {amountRange[0].toLocaleString('en-GB', {
                minimumFractionDigits: 2,
              })}
            </span>
            <span className="payment-list-filter-dropdown__amount-value">
              £
              {amountRange[1].toLocaleString('en-GB', {
                minimumFractionDigits: 2,
              })}
            </span>
          </div>
          <Slider
            value={amountRange}
            onChange={handleAmountRangeChange}
            min={minAmount}
            max={maxAmount}
            step={10}
            valueLabelDisplay="auto"
            className="amount-slider"
          />
        </div>
        <div className="payment-list-filter-dropdown__divider"></div>
        <div className="payment-list-filter-dropdown__actions">
          <FrontdeskButton
            variant="secondary"
            title="Reset"
            onClick={handleResetFilters}
            className="reset-button"
          />
          <FrontdeskButton
            variant="primary"
            title={`Apply${selectedPaymentMethods.length > 0 ? `(${selectedPaymentMethods.length})` : ''}`}
            onClick={handleApplyFilters}
          />
        </div>
      </div>
    </div>
  );
};
